export function getArrayTotal(answer: unknown): number {
  if (!Array.isArray(answer)) {
    return 0;
  }

  return answer.reduce((total, value) => total + Number(value || 0), 0);
}

export function getMinMaxValidationMessage(min?: number, max?: number): string | undefined {
  const hasMin = min !== undefined && !Number.isNaN(min);
  const hasMax = max !== undefined && !Number.isNaN(max);

  if (hasMin && hasMax) {
    return `Please enter a number between ${min.toLocaleString()} and ${max.toLocaleString()}`;
  }

  if (hasMin) {
    return `Please enter a number greater than or equal to ${min.toLocaleString()}`;
  }

  if (hasMax) {
    return `Please enter a number less than or equal to ${max.toLocaleString()}`;
  }

  return undefined;
}

export function validateMinTotal(answer: unknown, minTotal?: number): boolean {
  if (!minTotal) {
    return true;
  }

  return getArrayTotal(answer) >= minTotal;
}

export function hasValue(value: unknown): boolean {
  return value !== null && value !== undefined && String(value).length > 0;
}

export function isInteger(value: unknown): boolean {
  return Number(value) % 1 === 0;
}

export function nonNegative(value: unknown): boolean {
  return Number(value) >= 0;
}

export function inAllowedRange(value: unknown, min?: number, max?: number): boolean {
  if (value === undefined) {
    return false;
  }

  const numeric = Number(value);

  if (Number.isNaN(numeric)) {
    return false;
  }

  if (min !== undefined && numeric < min) {
    return false;
  }

  if (max !== undefined && numeric > max) {
    return false;
  }

  return true;
}
